import { AdbScrcpyForwardConnection, AdbScrcpyReverseConnection, } from "../connection.js";
import { AdbScrcpyOptionsBase } from "./types.js";
export class AdbScrcpyOptions1_16 extends AdbScrcpyOptionsBase {
    createConnection(adb) {
        const options = {
            // Old versions always have control stream no matter what the option is
            // Pass `control: false` to `Connection` will disable the control stream
            control: true,
            sendDummyByte: true,
            sendDeviceMeta: true,
        };
        if (this.value.tunnelForward) {
            return new AdbScrcpyForwardConnection(adb, options);
        }
        else {
            return new AdbScrcpyReverseConnection(adb, options);
        }
    }
}
//# sourceMappingURL=1_16.js.map